export default "__VITE_ASSET__BA0$uqDb__"